import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AxiosCommonError } from '../../../../../../../shared/types';
import { handleError } from '../../../../../../ui/err/handleError';

import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';
import { IManualFileUploadCompleteParams } from '../../../../../../../shared/apis/ai-agent/file/types';

export default function usePostCompleteFileUpload() {
  return useMutation({
    mutationFn: (params: IManualFileUploadCompleteParams) => aiAgentApis.file.postCompleteFileUpload(params),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
